import { useQuery } from '@gogame/query';

import { loadColumns } from '../sources/DataTable';
import { columns } from './queryKeyFactory';

export const useLoadColumns = () => {
  return useQuery(columns(), (_, { signal }) => loadColumns({}, { signal }), {
    enabled: true,
  });
};
